import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import walkthroughIds from '../../../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import FieldToolTip from 'components/forms/new/FieldToolTip';

const OCCVisibleScopeField = ({
    value,
    onChange,
    options,
    darkMode,
    error,
    showError,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const scopeData = (options || []).map((option) => ({
        id: option.value,
        name: option.label,
    }));

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!error && showError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Visible Scope{' '}
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Determine visibility and service creation level.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <DropDown
                        id="visibleScope"
                        name="visibleScope"
                        data={scopeData}
                        shownValue="name"
                        currentId={value}
                        alphabetical={false}
                        isClearable={false}
                        walkthroughId={
                            walkthroughIds.serviceProfiles?.ufVisibleScopeSelect
                        }
                        placeholder="- Select Visible Scope -"
                        darkMode={darkMode}
                        width="100%"
                        handleSelectChange={(item) => onChange(item?.id ?? '')}
                    />
                    {showError && (
                        <Text
                            color="red.500"
                            fontSize="xs"
                            mt={1}
                            textAlign="right">
                            {error}
                        </Text>
                    )}
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Determine visibility and service creation level."
                        ariaLabel="occ-visible-scope-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default OCCVisibleScopeField;
